import { ele, CablesConstants, TalkerAPI } from "cables-shared-client";
import Search from "./search.js";
import Nav from "./nav.js";
import Buttons from "./buttons.js";
import Shortcuts from "./shortcuts.js";
import Tabs from "./tabs.js";
import ActivityFeed from "./activityfeed.js";
import Cookies from "./cookies.js";
import Login from "./login.js";
import Favs from "./favs.js";
import api from "./api.js";
import Tables from "./tables.js";
import Projects from "./projects.js";

class CablesWeb
{
    constructor()
    {
        this.env = {
            "loggedIn": false,
            "env": "live",
            "envTitle": "",
            "isDev": () =>
            {
                return this.env.env === "dev";
            }
        };
        this.isOnBeforeUnload = false;
        this.isIframe = false;
        this._ignoreAutoSuggestRequest = false;
    }

    init(loggedIn, env, envTitle)
    {
        this.isIframe = ele.byQuery("body").classList.contains("framed");
        if (loggedIn) this.env.loggedIn = loggedIn;
        if (env) this.env.env = env;
        if (envTitle) this.env.envTitle = envTitle;

        this.nav = new Nav();
        this.search = new Search();
        this.buttons = new Buttons();
        this.shortcuts = new Shortcuts();
        this.tabs = new Tabs();
        this.tables = new Tables();
        this.activityFeed = new ActivityFeed();
        this.cookies = new Cookies();
        this.favs = new Favs();
        this.api = api;

        this.login = new Login();
        this.projects = new Projects();

        const toHighlight = document.querySelectorAll(".hljs");
        toHighlight.forEach((element) =>
        {
            hljs.highlightElement(element);
        });

        this.catHide();
    }

    catHide()
    {
        const catClosed = localStorage.getItem("catClose") || 0;
        const cat = ele.byId("sadcat");

        if (cat)
        {
            if (Date.now() - catClosed > (Math.random() + 3) * 2 * 60 * 60 * 1000) cat.classList.remove("hidden");
            else cat.classList.add("hidden");
        }
    }

    catClose()
    {
        localStorage.setItem("catClose", Date.now());

        this.catHide();
    }

    initializeAutosuggestsFromApi(inputElements, options = {})
    {
        const fillSuggestionList = (e) =>
        {
            if (this._ignoreAutoSuggestRequest) return;

            const el = e.target;
            const search = el.value;
            if (options.minLength && search.length < options.minLength) return;
            const url = new URL(el.dataset.autosuggest, "https://cables.gl/"); // stephan: baseurl placeholder to manipulate getstring in next line, value is ignored
            url.searchParams.set("ac", search);
            api.get(url.pathname + url.search, (response) =>
            {
                const suggestions = [];
                response.data.forEach((d) =>
                {
                    const suggestion = {
                        "title": d[el.dataset.autosuggestTitlefield],
                        "value": d[el.dataset.autosuggestValuefield]
                    };
                    if (d.image)
                    {
                        suggestion.image = d.image;
                    }
                    if (d.inactive)
                    {
                        suggestion.inactive = d.inactive;
                    }
                    suggestions.push(suggestion);
                });
                if (!this._ignoreAutoSuggestRequest)
                {
                    this.showInputSuggestions(el, suggestions, options);
                }
            });
        };

        if (inputElements)
        {
            inputElements.forEach((inputElement) =>
            {
                const focusListener = (e) =>
                {
                    this._ignoreAutoSuggestRequest = false;
                    fillSuggestionList(e);
                };
                inputElement.addEventListener("focus", focusListener);
                inputElement.addEventListener("input", fillSuggestionList);
                if (options.focusElement === inputElement)
                {
                    fillSuggestionList({ "target": inputElement });
                }
            });
        }
    }

    showInputSuggestions(targetEle, list, options = {})
    {
        // remove previous eventlisteners and hide already opened suggestions
        targetEle.onkeydown = null;
        document.querySelectorAll(".inputSuggestionList")
            .forEach((el) => { return el.remove(); });

        const div = document.createElement("div");
        div.classList.add("inputSuggestionList");

        for (let i = 0; i < list.length; i++)
        {
            const item = list[i];
            const element = document.createElement("div");
            element.classList.add("autosuggestLine");
            if (item.inactive)
            {
                element.classList.add("inactive");
            }
            element.dataset.value = item.value;
            element.dataset.title = item.title;
            if (item.image)
            {
                const imageElement = document.createElement("img");
                imageElement.src = item.image;
                element.appendChild(imageElement);
            }
            element.appendChild(document.createTextNode(item.title));
            div.appendChild(element);
        }

        const r = targetEle.getBoundingClientRect();

        div.style.top = r.top + r.height + window.scrollY + "px";
        div.style.left = r.left + "px";
        div.style.width = r.width + "px";

        const cstyle = getComputedStyle(targetEle);

        div.style.background = cstyle.background;
        div.style["background-color"] = cstyle["background-color"];

        div.dataset.selected = 0;
        const keypressListener = (event) =>
        {
            const key = event.key;

            targetEle.dataset.autosuggestTitle = "";
            targetEle.dataset.autosuggestValue = "";

            if (key === "ArrowDown")
            {
                div.dataset.selected++;
                if (div.dataset.selected > list.length) div.dataset.selected = list.length;
                div.childNodes.forEach((node, index) =>
                {
                    const itemNr = index + 1;
                    if (div.dataset.selected == itemNr)
                    {
                        node.classList.add("selected");
                        div.scrollTop = node.offsetTop;
                    }
                    else
                    {
                        node.classList.remove("selected");
                    }
                });
            }
            else if (key === "ArrowUp")
            {
                div.dataset.selected--;
                if (div.dataset.selected < 1) div.dataset.selected = 1;
                div.childNodes.forEach((node, index) =>
                {
                    const itemNr = index + 1;
                    if (div.dataset.selected == itemNr)
                    {
                        node.classList.add("selected");
                        div.scrollTop = node.offsetTop;
                    }
                    else
                    {
                        node.classList.remove("selected");
                    }
                });
            }
            else if (key === "Enter")
            {
                if (div.dataset.selected && div.dataset.selected > 0 && div.dataset.selected <= list.length)
                {
                    let newValue = list[div.dataset.selected - 1].title;
                    let newSuggestTitle = list[div.dataset.selected - 1].title;
                    let newSuggestValue = list[div.dataset.selected - 1].value;
                    if (options.append)
                    {
                        const seperator = options.seperator || ",";
                        newValue = targetEle.value += seperator + list[div.dataset.selected - 1].title;
                        newSuggestTitle = targetEle.dataset.autosuggestTitle + seperator + list[div.dataset.selected - 1].title;
                        newSuggestValue = targetEle.dataset.autosuggestValue + seperator + list[div.dataset.selected - 1].value;
                        newValue = newValue.replace(seperator + seperator, seperator);
                        newSuggestTitle = newSuggestTitle.replace(seperator + seperator, seperator);
                        newSuggestValue = newSuggestValue.replace(seperator + seperator, seperator);
                    }

                    targetEle.value = newValue;
                    targetEle.dataset.autosuggestTitle = newSuggestTitle;
                    targetEle.dataset.autosuggestValue = newSuggestValue;

                    targetEle.removeEventListener("keydown", keypressListener);
                    div.remove();
                    targetEle.dispatchEvent(new Event("change"));
                }
            }
        };

        targetEle.onkeydown = keypressListener;

        targetEle.addEventListener("blur", () =>
        {
            this._ignoreAutoSuggestRequest = true;
            setTimeout(() =>
            {
                targetEle.onkeydown = null;
                div.remove();
            }, 100);
        });

        div.addEventListener("pointerdown", (e) =>
        {
            let value = e.target.dataset.title;
            if (options.append)
            {
                value = targetEle.value + "," + e.target.dataset.title;
            }
            if (value && value !== "undefined")
            {
                targetEle.value = value;
                targetEle.dataset.autosuggestTitle = e.target.dataset.title;
                targetEle.dataset.autosuggestValue = e.target.dataset.value;
                targetEle.onkeydown = null;
                div.remove();
                targetEle.dispatchEvent(new Event("change"));
            }
        });

        document.body.appendChild(div);
    }

    executeFunctionByName(functionName, context, ...args)
    {
        const namespaces = functionName.split(".");

        const func = namespaces.pop();
        for (let i = 0; i < namespaces.length; i++)
        {
            try
            {
                context = context[namespaces[i]];
            }
            catch (e)
            {
                console.warn("missing context to execute function", functionName, context, args);
            }
        }
        if (!context || !context[func])
        {
            console.error("could not executeFunctionByName", functionName);
            return;
        }
        return context[func].apply(context, args);
    }

    getServiceWorkerSubscription(workerUrl, cb)
    {
        if (!navigator.serviceWorker)
        {
            cb("WEBPUSH_UNSUPPORTED");
            return;
        }
        navigator.serviceWorker.getRegistration(workerUrl).then((registration) =>
        {
            if (registration && registration.pushManager)
            {
                try
                {
                    registration.pushManager.getSubscription().then((sub) =>
                    {
                        cb(null, sub);
                    }).catch((e) =>
                    {
                        cb("ERROR_GETTING_SUBSCRIPTION", e);
                    });
                }
                catch (e)
                {
                    cb("ERROR", e);
                }
            }
            else
            {
                if (window.Notification)
                {
                    cb(null, null);
                }
                else
                {
                    cb("WEBPUSH_UNSUPPORTED");
                }
            }
        });
    }

    registerWebPushWorker(workerUrl, publicKey, cb)
    {
        if (!navigator.serviceWorker)
        {
            cb("WEBPUSH_UNSUPPORTED");
            return;
        }
        navigator.serviceWorker.ready.then((registration) =>
        {
            if (registration && registration.pushManager)
            {
                try
                {
                    Notification.requestPermission().then((permission) =>
                    {
                        if (permission === "granted")
                        {
                            registration.pushManager.subscribe({
                                "userVisibleOnly": true,
                                "applicationServerKey": publicKey
                            }).then((webPushSubscription) =>
                            {
                                if (webPushSubscription)
                                {
                                    if (cb) cb(null, webPushSubscription);
                                }
                                else
                                {
                                    if (cb) cb("FAILED_TO_SUBSCRIBE");
                                }
                            }).catch((e) =>
                            {
                                if (cb) cb("ERROR", e);
                            });
                        }
                        else
                        {
                            if (cb) cb("PERMISSION_NOT_GRANTED", "Check your browser settings to allow push notifications.");
                        }
                    });
                }
                catch (e)
                {
                    if (cb) cb("ERROR", e);
                }
            }
            else
            {
                if (cb) cb("WEBPUSH_UNSUPPORTED");
            }
        });
        navigator.serviceWorker.register(workerUrl, { "scope": "/", "updateViaCache": "all" });
    }

    unregisterWebPushWorker(workerUrl, cb)
    {
        if (!navigator.serviceWorker)
        {
            cb("WEBPUSH_UNSUPPORTED");
            return;
        }
        navigator.serviceWorker.ready.then((registration) =>
        {
            if (!registration)
            {
                if (cb) cb("NOT_REGISTERED");
            }
            else
            {
                registration.pushManager.getSubscription().then((subscription) =>
                {
                    if (subscription)
                    {
                        subscription.unsubscribe().then(() =>
                        {
                            if (cb) cb();
                        });
                    }
                    else
                    {
                        if (cb) cb("NOT_SUBSCRIBED");
                    }
                });
            }
        });
        navigator.serviceWorker.register(workerUrl, { "scope": "/", "updateViaCache": "all" });
    }

    getQueryVariable(variable)
    {
        const query = window.location.search.substring(1);
        const vars = query.split("&");
        for (let i = 0; i < vars.length; i++)
        {
            const pair = vars[i].split("=");
            if (pair[0] === variable)
            { return pair[1]; }
        }
        return false;
    }

    getSearchParams(key)
    {
        const p = {};
        location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, (s, k, v) => { p[k] = v; });
        return key ? p[key] : p;
    }

    getHandleBarHtml(name, vars)
    {
        // eslint-disable-next-line no-undef
        if (!cables.templates[name])
        {
            console.error("template not found: " + name);
            return "";
        }

        // eslint-disable-next-line no-undef
        return cables.templates[name](vars);
    }

    setHandleBarHtml(name, vars, element)
    {
        if (!element) return;
        element.innerHTML = this.getHandleBarHtml(name, vars);
    }

    parseDustJson(data, defaultValue = null)
    {
        if (!data) return defaultValue;
        let value = defaultValue;
        try
        {
            value = JSON.parse(data);
        }
        catch (e)
        {
            console.warn("failed to parse data from dust", data);
        }
        return value;
    }

    showCcIcons(text, show)
    {
        const element = ele.byId("patch-licence-text");
        if (element) element.innerText = text;

        if (show)
        {
            ele.show(element);
        }
        else
        {
            ele.hide(element);
        }
    }

    projectPagePatchList(projects, id, emptyText, pagination = {}, template = "project", html = "")
    {
        for (const i in projects)
        {
            const project = projects[i];
            const projectInfo = this.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername } });
            html += this.getHandleBarHtml(template, { "project": project, "projectInfo": projectInfo });
        }

        const el = document.getElementById(id);
        if (el)
        {
            el.innerHTML = html;
            if (!projects || projects.length === 0) el.innerHTML = "<div class=\"cute-12-phone\">" + emptyText + "</div>";
        }
    }

    embedPatch(params, callbackError = null)
    {
        let viewerUrl = params.sandboxUrl + "/sandboxviewer/" + params.projectId;
        viewerUrl = new URL(viewerUrl);

        let searchParams = viewerUrl.searchParams;

        if (params.queryString)
        {
            const parentSearchParams = new URLSearchParams(params.queryString);
            parentSearchParams.forEach((value, key) =>
            {
                searchParams.append(key, value);
            });
        }

        if (params.embedOverlay)
        {
            searchParams.append("embed", "true");
        }

        if (params.locationHash) viewerUrl += params.locationHash;

        const canvasiframe = document.createElement("iframe");
        canvasiframe.id = "canvasiframe";
        canvasiframe.frameBorder = "0";
        canvasiframe.allow = CablesConstants.IFRAME_OPTIONS_ALLOW;
        canvasiframe.src = viewerUrl;
        canvasiframe.style = "width:100%;";
        canvasiframe.title = "patch rendering canvas";
        canvasiframe.sandbox = CablesConstants.IFRAME_OPTIONS_SANDBOX;
        canvasiframe.setAttribute("allowfullscreen", "true");
        canvasiframe.setAttribute("webkitallowfullscreen", "true");
        canvasiframe.setAttribute("mozallowfullscreen", "true");
        document.getElementById(params.elementId).appendChild(canvasiframe);

        const frame = document.getElementById("canvasiframe");
        const talker = new TalkerAPI(frame.contentWindow);
        talker.addEventListener("sendPatch", (options, next) =>
        {
            let url = "project/" + params.projectId + "?nocache=" + Date.now();
            api.get(url, (data) =>
            {
                talker.send("patch", { "patch": data, "focusPatch": params.hasOwnProperty("focusPatch") ? params.focusPatch : true });
            }, (e) =>
            {
                console.warn("api error on url:", url);
                console.log(e);
                if (typeof callbackError === "function") callbackError(e);
            });
        });
    }

    startUploadManually()
    {
        const fileElem = document.getElementById("hiddenfileElem");
        if (fileElem) fileElem.click();
    }

    uploadFiles(files, url)
    {
        let formData = new FormData();
        formData.append(0, files[0]);

        let xhr = new XMLHttpRequest();
        xhr.open("POST", url);

        xhr.upload.onprogress = (event) =>
        {
            document.getElementById("uploadtext").innerText = "Uploading...";
        };

        xhr.onload = (e, r) =>
        {
            if (xhr.readyState === xhr.DONE)
            {
                if (xhr.status === 200 || xhr.status == 0)
                {
                    document.getElementById("uploadtext").innerText = "Processing...";
                    setTimeout(() => { document.location.reload(); }, 2000);
                }
                else
                {
                    document.getElementById("uploadtext").innerHTML = "Failed to Upload!<br/><br/>Status: " + xhr.status;
                }
            }
        };

        xhr.send(formData);
    }
}

export default new CablesWeb();
